import apiClient from '@/service/apiClient';

export type ResGetPopularLocations = {
  isSuccess: boolean;
  code: number;
  message: string;
  correlationId: string;
  result: {
    location: string;
    count: number;
  }[];
};

export const getPopularLocations = async (): Promise<ResGetPopularLocations> => {
  const { data } = await apiClient.get<ResGetPopularLocations>(
    '/app/products/v2/location/favorite'
  );
  return data;
};
